import fetch from '../fetch';

import utils from '../../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号'},

    {key:'orgName', label: '部门名称', width: 150},
    {key:'realName', label: '职工名称'},
    {key:'employeeCode', label: '职工代码'},
    {key:'termName', label: '所属学期'}
    
]);



/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('zgcp/assignview/list',  Object.assign(defaultsParams, keywords))
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearchTerm = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.get('zgcp/assignview/copy', keywords)
    .then(response => response.payload.meta.extParams || {})
    .then(params => params.lastTerm || {})
    .then(lastTerm => lastTerm.id)
}

/**
 * @method insert
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('zgcp/assignview/insert', data)
    .then(response => {
        if(response.code === 200) {
            message.success('温馨提示：添加成功！');
        }
    });
}

/**
 * @method copy
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const copy = (params) => {
    return fetch.post('zgcp/assignview/save/copy', params)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
            DataGrid.refresh();
        }
    }).catch(error => {
        return error;
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('zgcp/assignview/remove', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (orgId) => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove({orgId, ids: DataGrid.selections.join(',')}).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        DataGrid.refresh();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const getSelection =() => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'assignview/org'+ url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

export default {
    querySearch,
    insert,
    remove,
    columns,
    onSelect,
    batchRemove,
    getSelection,
    setRefresh,
    redirect,
    batchUpdate,
    querySearchTerm,
    copy
}